import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from "@angular/core";
import { FilterModelDto } from "../../models/filter.model";
import { Subscription, debounceTime } from "rxjs";
import { PaymentLinksDataService } from "./services/payment-links-data.service";
import { CheckBoxTable, SortDataColumn } from "../../models/table.model";
import { CheckboxTableService } from "../../services/checkbox-table.service";
import { SortTableService } from "../../services/sort-table.service";
import { TableSwitch } from "../../components/switch-table/switch-table.component";
import { TableHeightService } from "../../services/table-height.service";
import { DeletePaylinkDto, FormSelectModelDto, PayLinksModelDto, VistualPosCurrency } from "./models/paylinks.model";
import { ModalService } from "../../services/modal.service";
import { NotificationService } from "../../services/notification.service";
import { Router } from "@angular/router";
import { PermissionService } from "../../services/permission.service";
import { FilterSettingService } from "src/app/services/filter-setting.service";
import { FileNameSetService } from "src/app/services/file-name-set.service";
import { ContextMenuService } from "src/app/services/context-menu.service";
import { PaylinkUpdateDataService } from "./services/paylink-update-data.service";

@Component({
	selector: "app-payment-link-list",
	templateUrl: "./payment-link-list.component.html",
	styleUrls: ["./payment-link-list.component.scss"],
})
export class PaymentLinkListComponent implements OnInit, AfterViewInit, OnDestroy {
	@ViewChild("tableBlock") tableBlock: ElementRef | undefined;
	@ViewChild("tableBody") tableBody: ElementRef | undefined;

	delta = 150;
	currentPage = 0;
	lastPage!: boolean;
	selectedRow: any[] = [];

	isOpenAddDialog = false;
	isOpenDeletePaylinkSuccessDialog = false;
	isOpenDeletePaylinkDialog = false;
	isOpenEditPaylinkDialog = false;
	isOpenSendMailPaylinkDialog = false;

	paymentLinkList: PayLinksModelDto[] = [];
	paymentLinkDetail!: PayLinksModelDto;

	sortColumnData: SortDataColumn | undefined;

	isOpenFilter = false;
	filterAdditional: FilterModelDto[] | undefined;
	filterStatuses: FilterModelDto[] | undefined;
	filterPaylinkTypes: FilterModelDto[] | undefined;
	filterSinglePayments: FilterModelDto[] | undefined;
	filterCurrencies: FilterModelDto[] | undefined;

	currenciesList: VistualPosCurrency[] = [];
	paylinkTypesList: FormSelectModelDto[] = [];
	virtualPosList: FormSelectModelDto[] = [];

	deleteItems: string[] = [];

	subs: Subscription[] = [];

	isUsed = false;

	singleTokenDelete: string | undefined;
	sendMailToken: string | undefined;

	notificationText: string = "";
	notificationDescription: string = "";

	filterData: any;
	searchWord: string | undefined = "";
	fileName = "";

	title: string | undefined;

	constructor(
		private paymentLinkDataService: PaymentLinksDataService,
		private checkboxTableService: CheckboxTableService,
		private sortTableService: SortTableService,
		private tableHeightService: TableHeightService,
		private renderer: Renderer2,
		private modalService: ModalService,
		private notificationService: NotificationService,
		private router: Router,
		private filterSettingService: FilterSettingService,
		private fileNameSetService: FileNameSetService,
		public contextMenuService: ContextMenuService,
		private paylinkUpdateDataService: PaylinkUpdateDataService,
		public permissionService: PermissionService
	) {}

	ngOnInit() {
		this.initFilter();
		this.initFormData();

		this.initModal();
		this.initCheckboxSelectAll();
		this.sortColumn("DATE_LINK_FROM");
		this.fileNameInit();
	}

	ngAfterViewInit() {
		this.subs.push(
			this.tableHeightService.tableHeight$.subscribe({
				next: (res) => {
					this.renderer.setStyle(this.tableBlock?.nativeElement, "height", res);
				},
			})
		);
	}

	ngOnDestroy() {
		this.subs.forEach((item) => item.unsubscribe());
		this.sortTableService.sortColum$.next(undefined);
	}

	initCheckboxSelectAll() {
		this.subs.push(
			this.checkboxTableService.checkboxSelectAll$.subscribe({
				next: (res) => {
					this.selectedRow = [];
					if (res) {
						this.paymentLinkList.forEach((item) => this.selectedRow.push(item.token));
					}
				},
			})
		);
	}

	initModal() {
		this.subs.push(
			this.modalService.isModalOpen$.subscribe({
				next: (res) => {
					if (!res) {
						this.isOpenAddDialog = false;
						this.isOpenDeletePaylinkSuccessDialog = false;
						this.isOpenDeletePaylinkDialog = false;
						this.isOpenEditPaylinkDialog = false;
						this.isOpenSendMailPaylinkDialog = false;
					}
				},
			})
		);
	}

	getLinkList() {
		this.lastPage = true;
		this.paymentLinkDataService.loadPaymentLinksList(this.currentPage, this.searchWord, this.filterData).subscribe({
			next: (res) => {
				this.paymentLinkList.push(...res.content);
				this.currentPage++;
				this.lastPage = res.last;
				this.checkboxTableService.compareCount$.next();
			},
		});
	}

	initFormData() {
		this.paymentLinkDataService.loadPaymentFormData().subscribe({
			next: (res) => {
				this.paylinkTypesList = res.paylink_types;
				this.virtualPosList = res.virtual_pos;
				this.currenciesList = res.vp_currency;
			},
		});
	}

	initFilter() {
		this.subs.push(
			this.paymentLinkDataService.loadPaymentLinksListFilter().subscribe({
				next: (res) => {
					this.filterStatuses = res["statuses"];
					this.filterPaylinkTypes = res["paylinkTypes"];
					this.filterSinglePayments = res["singlePayments"];
					this.filterCurrencies = res["currencies"];
					this.filterAdditional = res["additional_params"];
				},
			})
		);

		this.subs.push(
			this.filterSettingService.filterSetData$.subscribe({
				next: (res) => {
					this.filterData = res;
					this.currentPage = 0;

					this.paymentLinkList = [];
					this.getLinkList();
				},
			})
		);

		this.subs.push(
			this.filterSettingService.inputSearch$.pipe(debounceTime(300)).subscribe({
				next: (res) => {
					this.paymentLinkDataService.loadSearchList(res).subscribe({
						next: (res) => {
							this.filterSettingService.responseSearchData$.next(res.content);
						},
					});
				},
			})
		);

		this.subs.push(
			this.filterSettingService.filterSearchWord$.subscribe({
				next: (res) => {
					this.searchWord = res;
				},
			})
		);

		this.subs.push(
			this.filterSettingService.filterAllReset$.subscribe({
				next: () => {
					this.searchWord = "";
					this.filterData = undefined;
					this.currentPage = 0;

					this.paymentLinkList = [];
					this.getLinkList();
				},
			})
		);
	}

	onScroll(event: any): void {
		const tableBodyHeight = this.tableBody?.nativeElement.clientHeight;
		const tableBlockHeight = this.tableBlock?.nativeElement.clientHeight;
		const scrollTable = event.target.scrollTop;
		if (tableBodyHeight - tableBlockHeight - scrollTable < this.delta && !this.lastPage) {
			this.getLinkList();
		}
	}

	checkChange(item: CheckBoxTable) {
		if (item.state) {
			this.setCheckboxState(item);
		} else {
			this.clearCheckboxState(item);
		}
		this.checkboxTableService.compareCount$.next();
		this.setStatusGroup();
	}

	// Подумать как вынести для общего пользования во всех таблицах
	setCheckboxState(item: CheckBoxTable) {
		this.selectedRow.push(item.id);
	}

	clearCheckboxState(item: CheckBoxTable) {
		for (let i = 0; i < this.selectedRow.length; i++) {
			if (item.id === this.selectedRow[i]) {
				this.selectedRow.splice(i, 1);
				return;
			}
		}
	}

	setStatusGroup() {
		let used = 0;
		if (this.selectedRow.length > 0) {
			for (let i = 0; i < this.paymentLinkList.length; i++) {
				if (this.selectedRow.includes(this.paymentLinkList[i].token)) {
					if (this.paymentLinkList[i].is_used) {
						used++;
					}
				}
			}
		}
		this.isUsed = used !== 0;
	}

	sortColumn(column: string) {
		this.sortColumnData = this.sortTableService.sort(column);

		const sort = `order=${this.sortColumnData?.order}&field=${this.sortColumnData?.field}`;
		this.sortTableService.sortColum$.next(sort);

		this.currentPage = 0;
		this.paymentLinkList = [];
		this.getLinkList();
	}

	toggleFilter(filterState: boolean) {
		this.isOpenFilter = filterState;
	}

	fileNameInit() {
		this.subs.push(
			this.fileNameSetService.setFileName$.subscribe({
				next: (res) => {
					this.fileName = res;
				},
			})
		);
	}

	upload() {
		this.paymentLinkDataService.loadFile().subscribe({
			next: (res) => {
				let link = document.createElement("a");
				link.href = (window.webkitURL || window.URL).createObjectURL(res);
				link.download = this.fileName;
				link.click();
			},
		});
	}

	toggleActivateLink(item: TableSwitch) {
		if (this.permissionService.hasPermission(["LINKS_EDIT"])) {
			this.paymentLinkDataService.changeStatus(item.id, !item.state).subscribe({
				next: () => {
					this.notificationService.setConfiguration(
						item.state ? "icon-2" : "icon-1",
						"warning",
						item.state ? "PAYMENT_LINK_PAGE.NOTIFICATION_CHANGE_STATUS.TITLE_UNLOCKED" : "PAYMENT_LINK_PAGE.NOTIFICATION_CHANGE_STATUS.TITLE_BLOCKED",
						"PAYMENT_LINK_PAGE.NOTIFICATION_CHANGE_STATUS.DESCRIPTION"
					);
					this.notificationService.showNotification();
				},
			});
		} else {
			this.notificationService.setConfiguration(
				"icon-1",
				"warning",
				"ROLE_PAGE.NOTIFICATION.PERMISSION_ERROR",
				"ROLE_PAGE.NOTIFICATION.PERMISSION_DESCRIPTION_1"
			);
			this.notificationService.showNotification();
		}
	}

	openAddLinkModal() {
		this.isOpenAddDialog = true;
	}

	addedLink() {
		this.modalService.closeModal();

		this.notificationService.setConfiguration(
			"icon-4",
			"success",
			"PAYMENT_LINK_PAGE.NOTIFICATION_ADD.TITLE",
			"PAYMENT_LINK_PAGE.NOTIFICATION_ADD.DESCRIPTION"
		);

		this.notificationService.showNotification();

		this.paymentLinkList = [];
		this.currentPage = 0;
		this.getLinkList();
	}

	deletePaylink() {
		let paylinkList: DeletePaylinkDto;
		if (this.singleTokenDelete) {
			paylinkList = {
				tokens: [this.singleTokenDelete],
			};
		} else {
			paylinkList = {
				tokens: this.selectedRow,
			};
		}
		this.paymentLinkDataService.deletePaylink(paylinkList).subscribe({
			next: () => {
				this.isOpenDeletePaylinkDialog = false;
				this.isOpenDeletePaylinkSuccessDialog = true;

				paylinkList.tokens.forEach((item) => {
					for (let i = 0; i < this.paymentLinkList.length; i++) {
						if (this.paymentLinkList[i].token === item) {
							this.paymentLinkList.splice(i, 1);
						}
					}
				});
			},
		});
		this.selectedRow = [];
	}

	editedLink(token: string) {
		this.paymentLinkDataService.loadDetailPaylink(token).subscribe({
			next: (res) => {
				for (let i = 0; i < this.paymentLinkList.length; i++) {
					if (this.paymentLinkList[i].token === token) {
						this.paymentLinkList[i] = res;
						this.modalService.closeModal();
						this.selectedRow = [];
						this.notificationService.setConfiguration(
							"icon-2",
							"warning",
							"PAYMENT_LINK_PAGE.NOTIFICATION.TITLE",
							"PAYMENT_LINK_PAGE.NOTIFICATION.DESCRIPTION"
						);
						this.notificationService.showNotification();
						return;
					}
				}
			},
		});
	}

	openEditModal(token?: string | undefined) {
		let tokenEdit: string;
		if (token) {
			tokenEdit = token;
		} else {
			tokenEdit = this.selectedRow[0];
		}

		this.paymentLinkDataService.loadDetailPaylink(tokenEdit).subscribe({
			next: (res) => {
				this.paymentLinkDetail = res;
				this.paylinkUpdateDataService.paymentLinkDetail$.next(res);
				this.isOpenEditPaylinkDialog = true;
			},
		});
	}

	openDeleteDialog(token?: string | undefined) {
		if (token) {
			this.singleTokenDelete = token;
			this.deleteItems = [token];
		} else {
			this.singleTokenDelete = undefined;
			this.deleteItems = this.selectedRow;
		}
		this.isOpenDeletePaylinkDialog = true;
	}

	openSendMail(token: string) {
		this.sendMailToken = token;
		this.isOpenSendMailPaylinkDialog = true;
	}

	copyPaylink(token: string) {
		this.paymentLinkDataService.copyPaylink(token, "PAY_LINK").subscribe({
			next: (res) => {
				navigator.clipboard.writeText(res).then(() => {
					this.notificationService.setConfiguration(
						"icon-2",
						"warning",
						"PAYMENT_LINK_PAGE.NOTIFICATION_LINK.TITLE",
						"PAYMENT_LINK_PAGE.NOTIFICATION_LINK.DESCRIPTION"
					);
					this.notificationService.showNotification();
				});
			},
		});
	}

	copyQr(token: string) {
		this.paymentLinkDataService.copyPaylink(token, "QR_PAY").subscribe({
			next: (res) => {
				const data = `data:image/png;base64,${res}`;

				fetch(data)
					.then((res) => res.blob())
					.then((res) => {
						navigator.clipboard
							.write([
								new ClipboardItem({
									[res.type]: res,
								}),
							])
							.then(() => {
								this.notificationService.setConfiguration(
									"icon-2",
									"warning",
									"PAYMENT_LINK_PAGE.NOTIFICATION_QR.TITLE",
									"PAYMENT_LINK_PAGE.NOTIFICATION_QR.DESCRIPTION"
								);
								this.notificationService.showNotification();
							});
					});
			},
		});
	}

	openPaymentHistory(token: string) {
		this.router.navigate([`/payment-list`], {
			queryParams: {
				paylink_token: token,
			},
		});
	}

	sendMailSuccess() {
		this.notificationService.setConfiguration(
			"icon-2",
			"warning",
			"PAYMENT_LINK_PAGE.NOTIFICATION_MAIL.TITLE",
			"PAYMENT_LINK_PAGE.NOTIFICATION_MAIL.DESCRIPTION"
		);
		this.notificationService.showNotification();
	}
}
